import { inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map, switchMap, take } from 'rxjs/operators';
import { IdentityService } from './identity.service';

const TOKEN_REFRESH_BUFFER_MS = 2 * 60 * 1000; // 2 minutes

@Injectable({ providedIn: 'root' })
export class TokenService {
    private readonly identityService = inject(IdentityService);

    getAccessToken(): Observable<string | null> {
        return this.identityService.stateChanges.pipe(
            take(1),
            switchMap(state => {
                if (!state.user || !state.accessToken) {
                    return of(null);
                }

                const expiresAt = state.user.exp * 1000;
                if (expiresAt - Date.now() < TOKEN_REFRESH_BUFFER_MS) {
                    return this.identityService.refresh(false).pipe(
                        map(() => this.identityService.currentState.accessToken),
                    );
                }

                return of(state.accessToken);
            }),
        );
    }
}
